module.exports = __webpack_public_path__ + "static/img/triad.ef440a49.png";